import { render, staticRenderFns } from "./HeaderAcademy.vue?vue&type=template&id=7804755e&scoped=true&"
import script from "./HeaderAcademy.vue?vue&type=script&lang=js&"
export * from "./HeaderAcademy.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAcademy.vue?vue&type=style&index=0&id=7804755e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7804755e",
  null
  
)

export default component.exports